export const actionTypes = {
  SET_BLUR_: 'SET_BLUR',
  SET_FOCUS: 'SET_FOCUS',
}

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_BLUR:
      return {
        ...state,
        isFocused: false,
      }
    case actionTypes.SET_FOCUS:
      return {
        ...state,
        isFocused: true,
      }
    default:
      throw new Error('action taken on input that cannot be handled')
  }
}
